import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { SpinnerCircular } from "spinners-react";
import http from "../services/http";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";

export default function UpdateUserInfo() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [initialValues, setInitialValues] = useState({ email: "", phone: "" });
  const userDetails = localStorage.getItem("signupUserDetails");
  const { email, phone,id } = JSON.parse(userDetails);


  // Retrieve user details from local storage
  useEffect(() => {
    if (userDetails) {
      
      setInitialValues({ email, phone });

    }
  }, []);

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format").required("Emai is required"),
    phone: Yup.string()
    .required("Phone is required")
    // .matches(
    //   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
    //   "Phone number is not valid"
    // ),
  });

  const updateUserInfo = async (values) => {
    setLoading(true);
    http
      .put(`public/analyst/edit-email-phone/${id}`, {
        email: values.email,
        phone: values.phone,
      })
      .then((res) => {
        setLoading(false);
        showToast("success", res.data.message,{
          autoClose: 3000
        });
        localStorage.setItem("signupUserDetails", JSON.stringify({ id:id,email:values.email, phone:values.phone }));
        setTimeout(() => {
          navigate("/email-phone-verification");
        }, 5000);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error ", error.response.data.errors);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={updateUserInfo}
        enableReinitialize={true}
      >
        {({ values, handleChange, handleBlur, handleSubmit }) => (
          <>
            <section className="login_wraper">
              <div className="login_inner">
                <div className="login_logo mb_40">
                  <img src={Logo} alt="" />
                </div>
                <h1 className="mb_30 main_title">Update Your Details</h1>
                <p className="mb_40 them_para">
                  Please enter your email and phone number to update your information.
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="form-group icon">
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange("email")}
                      onBlur={handleBlur("email")}
                      value={values.email}
                      className="custom_input form-control"
                      placeholder="Email ID"
                    />
                    <div style={{ color: "red",marginBottom:"5px"}}>
                      <ErrorMessage name="email" />
                    </div>
                  </div>
                  <div className="form-group icon">
                    <input
                      type="text"
                      name="phone"
                      onChange={handleChange("phone")}
                      onBlur={handleBlur("phone")}
                      value={values.phone}
                      className="custom_input form-control"
                      placeholder="Phone Number"
                    />
                    <div style={{ color: "red"}}>
                      <ErrorMessage name="phone" />
                    </div>
                  </div>

                  <div style={{ padding: 2, marginLeft: 40 }}>
                    <h6 style={{ color: "red", alignSelf: "center" }}>{error}</h6>
                  </div>
                  <div className="btn_wraper">
                    <button
                      type="submit"
                      className="them_btn mt_40 mb_30"
                      disabled={loading}
                    >
                      {loading ? (
                        <SpinnerCircular style={{ height: "40", marginTop: "7" }} />
                      ) : (
                        "Update Info"
                      )}
                    </button>
                  </div>
                </form>
                <Link to="/email-phone-verification">
                  <p className="btn-link d-block" style={{ cursor: "pointer" }}>
                    Go Back
                  </p>
                </Link>
              </div>
            </section>
          </>
        )}
      </Formik>
      <ToastContainer />

    </>
  );
}
